import { getCurrentCardState, appState } from './state'
import { getCardPosition, isCardAnimating } from './cardPositions'

interface RenderDebugSnapshot {
    frame: number
    foundationsWithCards: number
    foundationRenderPresence: number[]
    animatedFoundationCards: number
    topFoundationOverlays: number
    nonTopFoundationVisibleCount: number
    tableauBottom: number
    viewportBottom: number
    tableauOverflowPx: number
}

let _frameCounter = 0
let _lastSnapshot: RenderDebugSnapshot | null = null
let _enabled = false

function enableRenderDebug(): void {
    _enabled = true
}

function disableRenderDebug(): void {
    _enabled = false
}

function isRenderDebugEnabled(): boolean {
    return _enabled
}

export function resetRenderDebugFrameCounter(): void {
    _frameCounter = 0
    _enabled = true
}

export function getRenderDebugSnapshot(): RenderDebugSnapshot | null {
    return _lastSnapshot
}

export function updateRenderDebugSnapshot(): void {
    if (!_enabled) return

    const state = getCurrentCardState()
    if (!state || appState.windowHeight == null || appState.cardHeight == null) return

    _frameCounter++

    const foundationsWithCards = state.foundation.filter((pile) => pile.length > 0).length
    const foundationRenderPresence = state.foundation.map((pile) => {
        if (pile.length === 0) return 0
        const top = pile[pile.length - 1]
        const pos = getCardPosition(top)
        return Number(Number.isFinite(pos.x) && Number.isFinite(pos.y))
    })

    const animatedFoundationCards = state.foundation.reduce((sum, pile) => {
        return sum + pile.filter((card) => isCardAnimating(card)).length
    }, 0)

    const topFoundationOverlays = state.foundation.reduce((sum, pile) => {
        if (pile.length === 0) return sum
        return sum + (isCardAnimating(pile[pile.length - 1]) ? 1 : 0)
    }, 0)

    const nonTopFoundationVisibleCount = state.foundation.reduce((sum, pile) => {
        if (pile.length < 2) return sum
        const secondTop = pile[pile.length - 2]
        const pos = getCardPosition(secondTop)
        const hasCoords = Number(Number.isFinite(pos.x) && Number.isFinite(pos.y))
        return sum + hasCoords
    }, 0)

    let tableauBottom = 0
    for (const pile of state.tableau) {
        if (pile.length === 0) continue
        const last = pile[pile.length - 1]
        const pos = getCardPosition(last)
        tableauBottom = Math.max(tableauBottom, pos.y + appState.cardHeight)
    }

    const viewportBottom = appState.windowHeight
    const tableauOverflowPx = Math.max(0, Math.round(tableauBottom - viewportBottom))

    _lastSnapshot = {
        frame: _frameCounter,
        foundationsWithCards,
        foundationRenderPresence,
        animatedFoundationCards,
        topFoundationOverlays,
        nonTopFoundationVisibleCount,
        tableauBottom,
        viewportBottom,
        tableauOverflowPx,
    }
}
